import "../../assets/css/pin.css";
import { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import { getStatus } from "./method";
import Encryptor from "../../utils/Encryptor.js";
import Swal from "sweetalert2";

export default function Enrolled() {
    const location = useLocation();
    const navigate = useNavigate();

    const { state } = useParams();

    const [loading, setLoading] = useState(false);
    const [data] = useState(location.state?.data);

    const time = 15;
    const [timer, setTimer] = useState(time); // Timer state    

    const handleContinuar = async (e) => {
        e.preventDefault();
        window.location.href = data?.link;
    };

    // Función para renderizar los pasos comunes
    const renderSteps = (steps) => {
        return steps.map((step, index) => (
            <div key={index} className="mb-3">{step}</div>
        ));
    };

    // Contenido común en ambas condiciones
    const commonContent = (
        <>
            {!isMobile && (
                <div className="mb-3 form-group col-md-12 text-center">
                    <img src={data?.image} alt="QR" width={250} />
                </div>
            )}
            <div className="mb-3">
                Antes de comenzar, verifica que la cámara esté habilitada en tu teléfono.
            </div>
        </>
    );

    // Pasos específicos dependiendo de si está registrado o no
    const enrolledSteps = [
        "1. Haz clic en el botón continuar y serás dirigido al validador de identidad.",
        "2. Ubica tu rostro en el marco ovalado y sigue las instrucciones de 'acercarte' o 'alejarte' de la cámara.",
        "Una vez valido, continúa el proceso en tu sitio de AFP Modelo."
    ];

    const notEnrolledSteps = [
        "1. Ten a mano tu cédula vigente y en buen estado.",
        "2. Haz clic en el botón continuar y serás dirigido al validador de identidad.",
        "3. Coloca tu cédula dentro del marco que aparecerá en pantalla.",
        "4. Ubica tu rostro en el marco ovalado y sigue las instrucciones de 'acercarte' o 'alejarte' de la cámara.",
        "Una vez valido, continúa el proceso en tu sitio de AFP Modelo."
    ];

    useEffect(() => {
        if (state === "notok") {
            Swal.fire({
                icon: "warning",
                title: "Validación",
                text: "No hemos podido validar tu identidad. Por favor, inténtalo de nuevo más tarde.",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
                customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-danger",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate("/pin");
                }
            });
        }

        if (state === "begin") {
            if (timer > 0) {
                const interval = setInterval(() => {
                    setTimer((prevTimer) => prevTimer - 1);
                }, 1000);

                // Limpiar el intervalo cuando el componente se desmonte o cambie el timer
                return () => clearInterval(interval);
            } else if (timer === 0) {
                setTimer(time); // Restablecer el timer a su valor inicial

                // Función asíncrona para manejar la llamada de datos
                const fetchData = async () => {
                    try {
                        const responseGetStatus = await getStatus(data.instance, data.token);

                        var response = JSON.parse(responseGetStatus.resultado.respuesta);

                        if (response.status == "OK") {
                            if (response.statusCode == "200") {
                                const crypto = new Encryptor();
                                const encrypted = crypto.encrypt(data.id);

                                navigate(`/pin/update-info/${encrypted}`);
                            } else {
                                Swal.fire({
                                    icon: "warning",
                                    title: "Validación",
                                    text: response.result.ERROR,
                                    confirmButtonText: "Ok",
                                    allowOutsideClick: false,
                                    customClass: {
                                        confirmButton: "btn btn-success",
                                        cancelButton: "btn btn-danger",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        navigate("/pin");
                                    }
                                });
                            }
                        }
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                };

                fetchData(); // Llamada a la función asíncrona              
            }
        }
    }, [timer, data]);

    return (
        <div className="container">
            <div className="card formulario pin mt-5 mb-5">
                <div className="card-header">
                    <div className="form-row">
                        <div className="titulo">
                            Formulario de Retiro de Pensión Anticipada por Enfermedad Terminal
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="subtitulo mt-3">Modificación datos de contacto</div>
                    </div>
                    <div className="form-row">
                        <div className="subtitulo-2 mt-3">
                            <strong>Valida tu identidad</strong>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="form-row">
                        <div className="mt-3 body-text">
                            {state === "begin" && data.isEnrolled ? renderSteps(enrolledSteps) : renderSteps(notEnrolledSteps)}
                            {state === "begin" ? commonContent : ""}
                        </div>
                    </div>
                    {isMobile && (
                        <div className="mt-4 text-center">
                            <div className="form-group mb-2">
                                <Button
                                    variant="success"
                                    className="col-md-12"
                                    onClick={handleContinuar}
                                >
                                    {loading ? <Spinner animation="border" variant="light" size="sm" /> : "Continuar"}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
